const base = 'search/';
export const UPDATE_ZIPCODE = `${base}updateZipcode`;
export const UPDATE_RADIUS = `${base}updateRadius`;
export const SET_ERROR_MESSAGE = `${base}setErrorMessage`;
export const SET_SEARCH_ACTIVE = `${base}setSearchActive`;
export const SEARCH = `${base}search`;
